import React from "react";
import { crossIcon } from "../../asset";
interface props {
  children: React.ReactNode;
  className?: string;
  onClose?: () => void;
  isCross?: boolean;
}
export default function ModalLayout({
  children,
  className,
  onClose,
  isCross = true,
}: props) {
  return (
    <div className="fixed w-full h-full left-0 top-0 z-50 flex md:items-center justify-center items-end  ">
      <div
        className="w-full h-full bg-slate-900/40 absolute left-0 top-0 z-10 backdrop-blur-sm"
        onClick={onClose}></div>
      <div className="relative z-50 min-w-[10vw] md:w-max w-full  ">
        {isCross && (
          <div
            className="bg-white rounded-full p-1 absolute -top-11 right-0 cursor-pointer shadow-pop hover:scale-105 transition"
            onClick={onClose}
          >
            <img src={crossIcon} alt="close" className="w-6 h-6" />
          </div>
        )}
        <div className="app-scroll min-h-max max-h-[90vh] overflow-y-auto bg-white md:rounded-3xl rounded-t-3xl p-2 shadow-pop">
          {children}
        </div>
      </div>
    </div>
  );
}
